import { useSelector } from 'react-redux';

import { getMaxDocumentPanes } from 'utils/documentPanes';

import {
  selectDocumentPaneHostWidth,
  selectOpenDocumentPaneCount,
} from 'store/loanApplications/selectors';

/**
 * Whether another document pane fits beside the editor. Gated on the MEASURED width of the split
 * host (the editor content region, published to the store by LoanEditorSplitLayout) — not the raw
 * window width, since the nav/chrome means the content area is much narrower than the viewport.
 *
 * @returns {{ canAddPane: boolean, maxDocPanes: number }}
 */
export const useDocumentPaneCapacity = () => {
  const openPaneCount = useSelector(selectOpenDocumentPaneCount);
  const hostWidth = useSelector(selectDocumentPaneHostWidth);

  const maxDocPanes = getMaxDocumentPanes(hostWidth);

  return { canAddPane: openPaneCount < maxDocPanes, maxDocPanes };
};
